<section class="dashboard-main container-fluid">
  <div class="contents-main">
    <!-- <div class="profile-stats" *ngIf="plantCounts">
      <div class="profile-stat">
        <span class="profile-stat__label">Total Plants</span>
        <span class="profile-stat__value">{{ plantCounts.total_plants }}</span>
      </div>
      <div class="profile-stat">
        <span class="profile-stat__label"><span class="dot is-online" aria-hidden="true"></span>Online</span>
        <span class="profile-stat__value">{{ plantCounts.normal }}</span>
      </div>
      <div class="profile-stat">
        <span class="profile-stat__label"><span class="dot is-offline" aria-hidden="true"></span>Offline</span>
        <span class="profile-stat__value">{{ plantCounts.offline }}</span>
      </div>
      <div class="profile-stat">
        <span class="profile-stat__label"><span class="dot is-faulty" aria-hidden="true"></span>Faulty</span>
        <span class="profile-stat__value">{{ plantCounts.faulty }}</span>
      </div>
    </div> -->

    <div class="card table-card">
      <div class="table-toolbar">
        <h1 class="table-toolbar__title">Plant Profile</h1>
        <div class="sb-filter-holder sb-filter-holder--inline">
          <div class="input-wrapper">
            <ng-select class="sb-filter-field sb-filter-field--md" placeholder="Contract Type"
              (change)="selectContractType($event)" [items]="contractTypeList" bindLabel="name" bindValue="id">
            </ng-select>
          </div>

          <div class="input-wrapper">
            <ng-select class="sb-filter-field sb-filter-field--md" placeholder="Region" (change)="selectRegion($event)"
              [items]="regionList" bindLabel="name" bindValue="id" [loading]="regionLoading"
              loadingText="Loading regions...">
            </ng-select>
          </div>

          <div class="input-wrapper">
            <ng-select class="sb-filter-field sb-filter-field--md" placeholder="City" (ngModelChange)="selectCity($event)"
              [items]="cititiesList" bindLabel="name" bindValue="id" [(ngModel)]="selectedCity"
              [loading]="citiesLoading" loadingText="Loading cities..." notFoundText="No city found">
            </ng-select>
          </div>

          <div class="input-wrapper">
            <ng-select class="sb-filter-field sb-filter-field--md" placeholder="Plant Status"
              (change)="selectStatus($event)">
              <ng-option *ngFor="let status of plantStatuslst" [value]="status.id">{{ status.name }}</ng-option>
            </ng-select>
          </div>

          <div class="input-wrapper">
            <ng-select class="sb-filter-field sb-filter-field--md" placeholder="Plant Type"
              (change)="selectPlantType($event)">
              <ng-option *ngFor="let type of plantTypelst" [value]="type.id">{{ type.name }}</ng-option>
            </ng-select>
          </div>

          <div class="btn-group input-wrapper sb-filter-search-group" role="group">
            <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
              aria-label="Search plants" (input)="searchData($event)">
            <button type="button" class="btn sb-filter-search-btn" aria-label="Search">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        <button class="btn btn-dark rounded" (click)="downloadReport()" [disabled]="isDownloading">
          <ng-container *ngIf="!isDownloading">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="me-2">
              <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Download
          </ng-container>
          <ng-container *ngIf="isDownloading">
            <span class="spinner-border spinner-border-sm align-middle me-2"></span>
            Downloading
          </ng-container>
        </button>
      </div>

      <div class="table-wrap" [class.is-loading]="tableLoader">
        <div class="loaderwrapper" *ngIf="tableLoader">
          <span class="loader"></span>
        </div>
        <div class="table-main">
          <ngx-datatable class="material profile-table" [rows]="plants" [columnMode]="'force'" [headerHeight]="50"
            [footerHeight]="0" [rowHeight]="'auto'" [messages]="{ emptyMessage: 'No Plant found.' }"
            (activate)="$event.type === 'click' && openProfile($event.row)">
            <ngx-datatable-column name="Plant" [sortable]="false" [minWidth]="280" [width]="340">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="plant-cell">
                  <span class="plant-cell__dot" [ngClass]="'is-' + (row.status | lowercase)"
                    [title]="row.status" aria-hidden="true"></span>
                  <div class="plant-cell__text">
                    <a href="javascript:;" class="plant-cell__name">{{ row.plantName }}</a>
                    <span class="plant-cell__meta">
                      <span [ngClass]="'status-text is-' + (row.status | lowercase)">{{ row.status }}</span>
                      <ng-container *ngIf="row.plantAddress"> · {{ row.plantAddress }}</ng-container>
                    </span>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Installed Capacity (kWp)" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row"><span class="num">{{ row.capacity }}</span></ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Current Power (kW)" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row"><span class="num">{{ row.currentPower }}</span></ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Energy Today (kWh)" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row"><span class="num">{{ row.energyToday }}</span></ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="" [sortable]="false" [width]="110" headerClass="col-narrow"
              cellClass="col-narrow text-end">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row-actions">
                  <button type="button" class="profile-open" title="Structural Field Details"
                    [attr.aria-label]="'Structural field details for ' + row.plantName"
                    (click)="openStructuralDetails(row, $event)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M3 21h18" />
                      <path d="M5 21V10l7-6 7 6v11" />
                      <path d="M9 21v-6h6v6" />
                    </svg>
                  </button>
                  <button type="button" class="profile-open" [attr.aria-label]="'Open ' + row.plantName">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="m9 6 6 6-6 6" />
                    </svg>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>

          <div *ngIf="permissionsReady && !permissions.canView" class="no-access text-center p-4">
            You don’t have permission to view this data.
          </div>

          <div class="table-meta">
            <div class="entries">
              <span>Total Records: {{ total_items }}</span>
            </div>
            <nav class="table-pagination">
              <ul>
                <li>
                  <div class="go-to-page d-flex align-items-center">
                    <label>Go to Page:</label>
                    <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo" min="1"
                      [max]="total_pages" (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="button" (click)="goToPage(pageToGo); pageToGo = null"
                        [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                    </div>
                  </div>
                </li>
                <li><a class="init-bg" (click)="goToPage(1)" [class.disabled]="current_page === 1">1</a></li>
                <li><a class="no-bg" (click)="navigatePage('prev')"><i class="fa fa-chevron-left"></i></a></li>
                <li><a class="active">{{ current_page }}</a></li>
                <li><a class="no-bg" (click)="navigatePage('next')"
                    [class.disabled]="current_page === total_pages"><i class="fa fa-chevron-right"></i></a></li>
                <li><a class="init-bg" (click)="goToPage(total_pages)"
                    [class.disabled]="current_page === total_pages">{{ total_pages }}</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-structural-details-modal></app-structural-details-modal>
